import React from 'react';
import '../css/dropdown.less';

class DropDown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {value: this.props.initialValue};
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.setState({value: event.target.value});
    this.props.selectOption(event.target.value);
  }

  render() {
      const options = this.props.options;
      const key = this.props.displayKey;
    return (
        <div className={`dropdown ${this.props.className ? ' '+this.props.className : ''}`}>
          <select className='dropdown-menu' value={this.state.value} onChange={this.handleChange}>
              {
                  options.map((option, i)=>
                      <option key={`option-${i}`} value={i}>{option[key]}</option>
                  )
              }
          </select>
          <span className='dropdown-arrow'></span>
        </div>
    );
  }
}

export default DropDown;
